export const DEFAULT_WORLD_BACKGROUND_COLOR = "#72751b";

export const WORLD_SCENE_BACKGROUND_COLORS = {
  StoryWorldBootScene: DEFAULT_WORLD_BACKGROUND_COLOR,
  VillageScene: DEFAULT_WORLD_BACKGROUND_COLOR,
  VoidCity2Scene: DEFAULT_WORLD_BACKGROUND_COLOR,
  Route333Scene: "#6f6f50",
  WhisperingForestScene: "#3f5d24",
  NorthDocksScene: "#465f73",
  VoidCaveScene: "#161616",
  VoidCaveDepthsScene: "#161616",
  WestPassageScene: "#161616",
  WestGrottoScene: "#161616",
  RuneHollowScene: "#161616",
  DeepGalleryScene: "#161616",
  EastPassageScene: "#161616",
  CrystalBasinScene: "#161616",
  EchoVaultScene: "#161616",
  ShatteredReachScene: "#161616",
  ArenaScene: "#2a2434",
  MerchantScene: "#3a2c24",
  DecksmithScene: "#332836",
  GameHallScene: "#261438",
  QuestHallScene: "#2d2744",
};

export const getWorldSceneBackgroundColor = (sceneKey, fallbackColor = DEFAULT_WORLD_BACKGROUND_COLOR) =>
  WORLD_SCENE_BACKGROUND_COLORS[sceneKey] || fallbackColor;

export const applyWorldSceneBackground = (scene, fallbackColor = DEFAULT_WORLD_BACKGROUND_COLOR) => {
  const color = getWorldSceneBackgroundColor(scene?.scene?.key, fallbackColor);
  scene?.cameras?.main?.setBackgroundColor(color);
  return color;
};
